/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вью для попапа с номерами заказов в новой форме претензий
   */
  app.ClaimOrderNumbersView = app.View.extend({
    events: {
      'click .order': 'triggerUpdateOrderId',
    },
    /**
     * @inheritDoc
     */
    run: function () {
      this.popup = new als.Popup(this.$el);
      this.ordersNumbersTemplate = app.helpers.TemplateHelper.getTemplate('#orders-numbers-template');
    },
    /**
     * Отрисовка попапа с номерами заказов
     * @param {Array} orders Массив заказов
     * @param {number|string} currentOrderId Текущее значение в поле 'Номер заказа'
     */
    render: function (orders, currentOrderId) {
      this.$el.html(this.ordersNumbersTemplate({
        orders: orders,
        currentOrderNumber: currentOrderId,
        each: _.each,
      }));
      this.toggle(true);
    },
    /**
     * Открывает или закрывает попап в зависимости от переданного аргумента.
     * @param {boolean} isOpen Определяет, открыть или закрыть попап.
     */
    toggle: function (isOpen) {
      // костыль для лебедевского попапа
      setTimeout(function () {
        if (isOpen) {
          this.popup.open();
        } else {
          this.popup.close();
        }
      }.bind(this), 0);
    },
    /**
     * Триггерит событие при выборе номера заказа
     * @param {Event} event Событие клика по заказу
     */
    triggerUpdateOrderId: function (event) {
      var newOrderId = $(event.currentTarget).data('select-order');
      this.toggle(false);
      this.trigger('selectOtherOrder', newOrderId);
    }
  });
})(jQuery);

}.call(window));